<div class="transfer-detail__header">
  <div class="transfer-detail__heading">
    <span class="transfer-detail__title-icon" aria-hidden="true">
      <i-tabler name="file-description" class="icon-20"></i-tabler>
    </span>
    <div>
      <h3 class="transfer-detail__title">Detalle de transferencia</h3>
      <p class="transfer-detail__subtitle">
        Información operativa y de conciliación del movimiento.
      </p>
    </div>
  </div>

  <div class="transfer-detail__header-actions">
    <ng-container [ngSwitch]="data.estado?.toLowerCase()">
      <span
        *ngSwitchCase="'creado'"
        class="transfer-status transfer-status--created"
      >
        Creado
      </span>
      <span
        *ngSwitchCase="'rechazado'"
        class="transfer-status transfer-status--rejected"
      >
        Rebotado
      </span>
      <span
        *ngSwitchCase="'procesado'"
        class="transfer-status transfer-status--completed"
      >
        Conciliado
      </span>
      <span
        *ngSwitchCase="'en proceso'"
        class="transfer-status transfer-status--progress"
      >
        En Conciliación
      </span>
      <span *ngSwitchDefault class="transfer-status">
        {{ data.estado || '-' }}
      </span>
    </ng-container>

    <button
      type="button"
      mat-icon-button
      class="transfer-detail__icon-close"
      aria-label="Cerrar detalle de transferencia"
      (click)="onCancel()"
    >
      <i-tabler name="x" class="icon-18"></i-tabler>
    </button>
  </div>
</div>

<mat-dialog-content class="mat-typography transfer-detail__content">
  <section *ngIf="hasTransferSummary" class="transfer-detail__summary">
    <div class="transfer-detail__accounts">
      <div class="transfer-detail__account">
        <span class="transfer-detail__account-label">Cuenta cargo</span>
        <strong class="transfer-detail__account-name">
          {{ data.cuentaCargo || '-' }}
        </strong>
        <span class="transfer-detail__account-amount">
          {{ data.cuentaCargoTipo || 'S/' }}
          {{ data.monto != null ? ((data.monto ?? 0) | formatNumber) : '-' }}
        </span>
      </div>

      <div class="transfer-detail__direction" aria-hidden="true">
        <i-tabler name="arrow-right" class="icon-20"></i-tabler>
      </div>

      <div class="transfer-detail__account transfer-detail__account--destination">
        <span class="transfer-detail__account-label">Cuenta destino</span>
        <strong class="transfer-detail__account-name">
          {{ data.cuentaDestino || '-' }}
        </strong>
        <span class="transfer-detail__account-amount transfer-detail__account-amount--destination">
          {{ data.cuentaDestinoTipo || data.cuentaCargoTipo || 'S/' }}
          {{
            (data.montoDestino ?? data.monto) != null
              ? ((data.montoDestino ?? data.monto ?? 0) | formatNumber)
              : '-'
          }}
        </span>
      </div>
    </div>

    <div class="transfer-detail__meta">
      <div class="transfer-detail__meta-item">
        <span>Fecha de operación:</span>
        <strong>
          {{
            data.fechaOperacion
              ? (data.fechaOperacion | customDate | date : 'dd MMM yyyy')
              : '-'
          }}
        </strong>
      </div>
      <div *ngIf="hasExchangeRate" class="transfer-detail__meta-item">
        <span>Tipo de cambio:</span>
        <strong>S/ {{ (data.tipoCambio ?? 0) | formatNumber }}</strong>
      </div>
    </div>
  </section>

  <div class="transfer-detail__list">
    <div class="transfer-detail__item">
      <span class="transfer-detail__item-icon" aria-hidden="true">
        <i-tabler name="calendar-event" class="icon-20"></i-tabler>
      </span>
      <div class="transfer-detail__item-body">
        <span class="transfer-detail__item-label">Fecha de reprogramación</span>
        <span
          class="transfer-detail__item-value"
          [class.transfer-detail__item-value--empty]="!data.fechaReprogramacion"
        >
          {{
            data.fechaReprogramacion
              ? (data.fechaReprogramacion | customDate | date : 'dd MMM yyyy')
              : 'Solo aplica para transferencias rebotadas.'
          }}
        </span>
      </div>
    </div>

    <div class="transfer-detail__item">
      <span class="transfer-detail__item-icon" aria-hidden="true">
        <i-tabler name="cash" class="icon-20"></i-tabler>
      </span>
      <div class="transfer-detail__item-body">
        <span class="transfer-detail__item-label">Comisión bancaria</span>
        <span
          class="transfer-detail__item-value"
          [class.transfer-detail__item-value--empty]="!data.comision"
        >
          {{ data.comision ? data.cuentaCargoTipo || '' : '' }}
          {{
            data.comision
              ? ((data.comision ?? 0) | formatNumber)
              : 'No se aplicaron comisiones.'
          }}
        </span>
      </div>
    </div>

    <div class="transfer-detail__item">
      <span class="transfer-detail__item-icon" aria-hidden="true">
        <i-tabler name="calendar-check" class="icon-20"></i-tabler>
      </span>
      <div class="transfer-detail__item-body">
        <span class="transfer-detail__item-label">Fecha de recepción</span>
        <span
          class="transfer-detail__item-value"
          [class.transfer-detail__item-value--empty]="!data.fechaEfectiva"
        >
          {{
            data.fechaEfectiva
              ? (data.fechaEfectiva | customDate | date : 'dd MMM yyyy')
              : 'No hay una fecha de recepción definida.'
          }}
        </span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="transfer-detail__actions">
  <button
    type="button"
    mat-flat-button
    class="transfer-detail__close-button"
    (click)="onCancel()"
  >
    Cerrar
  </button>
</mat-dialog-actions>
